import React, { useState, useMemo } from 'react';
import { useNetworks } from '../hooks/useNetworks';
import { NetworkGrid } from '../components/network/NetworkGrid';
import { SearchBar } from '../components/common/SearchBar';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

export const HomePage = () => {
  const { networks, loading, error } = useNetworks();
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    hot: false,
    favorite: false,
    verified: false,
    public: false
  });

  const filteredNetworks = useMemo(() => {
    if (!networks) return [];
    
    return networks.filter(network => {
      const matchesSearch = !searchTerm || 
        network.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        network.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        network.code.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesFilters = 
        (!filters.hot || network.isHot) &&
        (!filters.favorite || network.isFavorite) &&
        (!filters.verified || network.isVerified) &&
        (!filters.public || network.isPublic);

      return matchesSearch && matchesFilters;
    });
  }, [networks, searchTerm, filters]);

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="alert alert-danger">Error loading networks: {error}</div>;

  return (
    <div className="fade-in">
      <h2 className="mb-4">Discover Networks</h2>
      
      <div className="mb-4">
        <SearchBar 
          value={searchTerm}
          onChange={setSearchTerm}
          placeholder="Search networks by name, description, or code..."
        />
        
        <div className="d-flex gap-2 flex-wrap">
          {Object.keys(filters).map(key => (
            <button
              key={key}
              className={'btn btn-sm ' + (filters[key] ? 'btn-primary' : 'btn-outline-primary')}
              onClick={() => setFilters({...filters, [key]: !filters[key]})}
            >
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <NetworkGrid networks={filteredNetworks} useNameInUrl={true} useCodeInUrl={false} />
    </div>
  );
};
